/**
 * Lib.Common: Button component declarations
 */


import ibButton             from './ib-button.vue';
import ibButtonArray        from './ib-button-array.vue';
import ibButtonBack         from './ib-button-back.vue';
import ibButtonGroup        from './ib-button-group.vue';
import ibButtonHook         from './ib-button-hook.vue';
import ibButtonLink         from './ib-button-link.vue';
import ibButtonRoute        from './ib-button-route.vue';
import ibButtonSubmit       from './ib-button-submit.vue';
import ibButtonToggle       from './ib-button-toggle.vue';


export default [
    ibButton,
    ibButtonArray,
    ibButtonBack,
    ibButtonGroup,
    ibButtonHook,
    ibButtonLink,
    ibButtonRoute,
    ibButtonSubmit,
    ibButtonToggle
];
